﻿'use strict'

import $ from 'jquery';
import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';
import * as _ from 'underscore';
import * as Bootstrap from 'bootstrap';

//import * as SignalR from 'signalr';

import tpl_customEventThemeColor from './tpl/customEventThemeColor.html';
import tpl_customEventThemeColorDesign from './tpl/customEventThemeColorDesign.html';

import language from '../../../common/language';
import View_Pagination from '../../../lib/views/pagination/pagination';
import View_CustomEvenThemeColorEditItem from './customEventThemeColorEditItem';
import View_CustomEvenThemeColorInsert from './customEventThemeColorInsert';
import View_CustomEvenThemeColorList from './customEventThemeColorList';
import View_Information from '../../../lib/views/information/information';
import * as Entities_Empty from '../../../lib/entities/empty';
import View_LayoutError from '../../../lib/views/layoutError/layoutError';
import View_Dialog2Button from '../../../lib/views/dialog2Button/dialog2Button';
import View_DialogWaiting from '../../../lib/views/dialogWaiting/dialogWaiting';
import * as Entities_CustomPush from '../../entities/customPush';
import * as Entities_UserAnalytic from '../../entities/userAnalytic';
import * as Entities_Memory_PositionPageable from '../../entities/memoryPositionPageable';
import * as Entities_Memory from '../../entities/memory';

import View_CustomHeader from '../region/customHeader/customHeader';

import config from '../../../common/config';
import Help from '../../helper/help';

export default View_LayoutError.extend({
    designRegion: '#designRegion_modal',
    getTemplate: function () {
        if (this.options.designMode) {
            return tpl_customEventThemeColorDesign();
        } else {
            return tpl_customEventThemeColor();
        }
    },
    regions: {
        customHeader: "#customHeader",
        customEventThemeColorEditItem: '#customEventThemeColorEditItem',
        customEventThemeColorInsert : '#customEventThemeColorInsert',
        customEventThemeColorList : '#customEventThemeColorList',
        customEventThemeColorPagination: '#customEventThemeColorPagination',
        customEventThemeColorListDefault: '#customEventThemeColorListDefault',
        customEventThemeColorPaginationDefault: '#customEventThemeColorPaginationDefault',
        information: "#customEventThemeColorInformation"
    },
    onBeforeShow: function () {
        //var tmpSelectedModelSetting = this.app.entities.collections.customModule.where({ EventId: this.localSetting.attributes.EventId, ModuleType: 98 })[0];
        //var data = JSON.parse(tmpSelectedModelSetting.attributes.Data);
        //var tmpCollection = new Entities_Memory_PositionPageable.Collection(data[0].Data.ThemeCollection);

        //var selectedModel = data[0].Data.ThemeCollectionSelected;

        //tmpCollection.each(function (model) {
        //    model.attributes.Selected = model.id == selectedModel ? 1 : 0;
        //});


        //this.model = new Entities_Memory.Model(data[0].Data);

        //this.customEventThemeColorEditItem.show(new View_CustomEvenThemeColorEditItem({ collection: this.collection, localSetting: this.localSetting, app: this.app }));
        this.customEventThemeColorInsert.show(new View_CustomEvenThemeColorInsert({ collection: this.collection, defaultCollection: this.options.collectionDefault, localSetting: this.localSetting, app : this.app }));
        this.customEventThemeColorList.show(new View_CustomEvenThemeColorList({ collection: this.collection, mainCollection: this.collection, localSetting: this.localSetting, app : this.app }));
        this.customEventThemeColorPagination.show(new View_Pagination({ collection: this.collection, app: this.app }));

        this.customEventThemeColorListDefault.show(new View_CustomEvenThemeColorList({ collection: this.options.collectionDefault, mainCollection: this.collection, localSetting: this.localSetting, app: this.app }));
        this.customEventThemeColorPaginationDefault.show(new View_Pagination({ collection: this.options.collectionDefault, app: this.app }));

        this.information.show(new View_Information({ collection: this.informationCollection, app: this.app }));

        var customHeaderModel = new Entities_Empty.Model();

        var customEvent = self.app.entities.collections.customEvent.fullCollection.where({ id: this.options.event});
        if (customEvent.length > 0) {
            customHeaderModel.attributes.Name = customEvent[0].attributes.Name;
        } else {
            customHeaderModel.attributes.Name = "";
        }

        customHeaderModel.attributes.Title = resources.X101078;
        customHeaderModel.attributes.ShowSave = false;
        customHeaderModel.attributes.ShowBack = true;

        this.customHeader.show(new View_CustomHeader({ app: this.app, model: customHeaderModel }));
    },
    initialize: function () {
        this.app = this.options.app;
        
        //this.listenTo(this.collection, 'change', this.render, this);
        this.informationCollection = new Entities_Empty.Collection();

        this.listenTo(this.collection, 'add', this.updateInformationCollection, this);
        this.listenTo(this.collection, 'remove', this.updateInformationCollection, this);

        this.localSetting = new Entities_Empty.Model();
        this.localSetting.attributes.EventId = this.options.eventId;

        var userChannel = Backbone.Radio.channel('app');
        var self = this;
        //userChannel.on('customEventThemeColor:pushMessage', function() {
        //    self.pushMessage(self.localSetting.attributes.LastMessage);
        //});
        this.listenTo(userChannel,'customEventThemeColor:pushMessage', function() {
            self.pushMessage(self.localSetting.attributes.LastMessage);
        });

        this.listenTo(userChannel, 'customHeader:iconSave', function () {
            self.customEventThemeColor_btnSave_click();
        });
        this.listenTo(userChannel, 'customHeader:iconBack', function () {
            self.customEventThemeColor_btnBack_click();
        });	

        this.signalR_init();

        this.setHasChanged(false);
    },
    signalR_init: function () {
        //this.IWannaChat = $.connection.Events4usHub;
        //$.connection.hub.start();
    },
    pushMessage: function(message)
    {
        var tmpMessage = this.localSetting.attributes.EventId + "#¤%&/()=?" + message;
        //this.IWannaChat.server.send(tmpMessage);

        var tmpModel = new Entities_CustomPush.Model();
        tmpModel.attributes.Message = tmpMessage;
        tmpModel.attributes.User = config.authUserId();
        tmpModel.attributes.id = this.localSetting.attributes.EventId;
        tmpModel.attributes.TokenKey = "";
        
        tmpModel.save(tmpModel, {
            silens :true,
            wait: true,
            success: function (response) {
                
            }});
    },
    help: function () {
        Help.help(this, true, 'customEventThemeColor');
    },
    setHasChanged: function (enable) {
        this.hasChanged = enable;
    },
    getHasChanged: function () {
        return this.hasChanged;
    },
    saveHasChanged: function (callback) {
        callback();
    },
    cancelHasChanged : function() {
    },
    modelHasChanged : function () {
    },
    ui: {
        'customEventThemeColor_btnBack': '#customEventThemeColor_btnBack',
        'customEventThemeColor_selectEvent': '#customEventThemeColor_selectEvent',
        'help': '#help',
        'designRegion_body': '#designRegion_body',
        'designRegion_btnOk': '#designRegion_btnOk',
        'customEventThemeColor_inputNameGroup': '#customEventThemeColor_inputNameGroup'
    },
    events: {
        'click @ui.customEventThemeColor_btnBack': 'customEventThemeColor_btnBack_click',
        'click @ui.customEventThemeColor_btnPushSubmit': 'btnPushSubmit',
        'change @ui.customEventThemeColor_selectEvent': 'selectEventChange',
        'click #help': 'help',
        'click @ui.designRegion_btnOk': 'designRegion_btnOk'
    },
    onRender: function () {
        //this.setupEvent();

        this.renderInformation();

        if (this.app.mode == 1) {
            this.ui.customEventThemeColor_inputNameGroup.css('display', 'none');
        }

        return this;
    },
    renderInformation: function () {
        this.informationCollection.reset();

        //No events
        if (this.collection.models.length <= 0) {
            var tmpModel = new this.informationCollection.model({ toastType: 3, header: resources.X100229, Information: resources.X100334 });
            this.informationCollection.add(tmpModel);
        }

        //Push not enable
        if (this.app.entities.models.configSubscription[0].attributes.EnablePush == false) {
            var tmpModel = new this.informationCollection.model({ toastType: 3, header: resources.X100229, Information: resources.X100346 });
            this.informationCollection.add(tmpModel);
        }

        this.app.renderInformation({ informationCollection: this.informationCollection });
    },
    updateInformationCollection: function () {
        this.renderInformation();
        this.informationCollection.trigger('change');
    },
    customViewEvent_setActive: function () {
        var array = [];

        if (this.localSetting.attributes.EventId != -1) {
            var tmp = { "id": this.localSetting.attributes.EventId };
            array.push(tmp);
        }

        var userChannel = Backbone.Radio.channel('app');
        userChannel.trigger('customViewEvent:setActive', array);
    },
    onAttach(){
        //this.customViewEvent_setActive();

        if (this.options.designMode) {
            var height = $(window).height() * 0.8;
            this.ui.designRegion_body.height(height);
        }

        
    },
    selectEventChange : function () {
        this.localSetting.attributes.EventId = parseInt(this.ui.customEventThemeColor_selectEvent.val());
        this.customViewEvent_setActive();

        //read the push collection
        var self = this;
        this.app.entities.collections.customEventPush.fetch({
            EventId: this.localSetting.attributes.EventId,
            readlist : true,
            success: function () {
                var userChannel = Backbone.Radio.channel('app');
                userChannel.trigger('customEventThemeColor:eventChanged');
            },
            error: function () {
            }
        });
    },
    //setupEvent: function () {
    //    var self = this;
    //    this.collection.fullCollection.forEach(function (entry) {
    //        self.ui.customEventThemeColor_selectEvent.append('<option value="' + entry.attributes.id + '">' + entry.attributes.Name + '</option>');
    //    });

    //    if (this.options.event != undefined && this.options.event != -1) {
    //        this.ui.customEventThemeColor_selectEvent.val(this.options.event.toString());
    //    }
        
    //    this.selectEventChange();
    //},
    
    designRegion_btnOk() {
        this.triggerMethod('dialog:close');

    },
    customEventThemeColor_btnSave_click: function (event) {
        var themeCollectionSelected = 1;

        this.collection.forEach(function (entry) {
            if (entry.attributes.Selected == 1) {
                themeCollectionSelected = entry.attributes.id;
            }
        });

        var customModule = self.app.entities.collections.customModule.where({ EventId: this.options.eventId, ModuleType: 98 })[0];
        var data = JSON.parse(customModule.attributes.Data);
        var customModule_data = new Entities_Memory.Model(data[0].Data);
        var tmpCollection = new Entities_Memory_PositionPageable.Collection(data[0].Data.ThemeCollection);

        customModule_data.attributes.ThemeCollection = this.collection.toJSON();

        customModule_data.attributes.ThemeCollectionSelected = themeCollectionSelected;

        var strJson = JSON.stringify(customModule_data.toJSON());
        customModule.attributes.Data = '[{ "Data" : ' + strJson + '}]';

        customModule.save(customModule.attribute, {
            silent: false,
            wait: true,
            success: function () {
            }
        });
    },
    customEventThemeColor_btnBack_click: function (event) {
        this.app.router.navigate("#customEventEditItem?id=" + this.options.eventId);
        this.app.router.customEventEditItem(this.options.eventId, this.options.scroll, 0, false, false);
    }
}, Backbone.Radio.Requests);
